import {
  TenantSelector as SharedTenantSelector,
  TenantSelectorField as SharedTenantSelectorField,
  type GetTenantsFn,
  type ITenantSelectorProps,
  type TenantSelectorFieldProps,
} from '@moko/ui';
import { getTenants } from '../../services/tenantService';

export const getTenantsAdapter: GetTenantsFn = async (
  abortController,
  pageSize,
  pageNo,
  orderBy,
  search
) => {
  const result = await getTenants(
    abortController,
    pageSize,
    pageNo,
    orderBy,
    search
  );
  return {
    items: result.items.map((tenant) => ({
      id: tenant.id,
      name: tenant.name,
    })),
    isLastPage: result.isLastPage,
  };
};

export type PortalTenantSelectorProps = Omit<
  ITenantSelectorProps,
  'getTenants'
>;

export const TenantSelector = (props: PortalTenantSelectorProps) => (
  <SharedTenantSelector {...props} getTenants={getTenantsAdapter} />
);

export type PortalTenantSelectorFieldProps = Omit<
  TenantSelectorFieldProps,
  'getTenants'
>;

export const TenantSelectorField = (props: PortalTenantSelectorFieldProps) => (
  <SharedTenantSelectorField {...props} getTenants={getTenantsAdapter} />
);
